/**
 * jQuery
 */
import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

/**
 * Selectize
 */
import selectize from '@selectize/selectize';

/**
 * Vue
 */
import Vue from 'vue';
import Languages from './components/registration/Languages.vue';
import Certificates from './components/registration/Certificates.vue';
import HigherEducationDegrees from './components/registration/HigherEducationDegrees.vue';
import EmploymentHistory from './components/registration/EmploymentHistory.vue';
import FileInput from './components/registration/FileInput.vue';
if (document.getElementById('form-register')) {
    new Vue({
        components: {
            Languages,
            Certificates,
            HigherEducationDegrees,
            EmploymentHistory,
            FileInput,
        },
    }).$mount('#form-register');
}

/**
 * International Telephone Input
 */
import intlTelInput from 'intl-tel-input';
window.intlTelInput = intlTelInput;

/**
 * Bootstrap
 */
import Dropdown from 'bootstrap/js/dist/dropdown';
import Collapse from 'bootstrap/js/dist/collapse';
import Alert from 'bootstrap/js/dist/alert';
import Tab from 'bootstrap/js/dist/tab';
import Tooltip from 'bootstrap/js/dist/tooltip';

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
const tooltipList = [...tooltipTriggerList].map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));

/**
 * Axios HTTP library
 */
import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Fancybox
 */
require('@fancyapps/fancybox');

/**
 * Swiper
 */
import Swiper, { Navigation, Pagination, Autoplay, Parallax, EffectFade } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, Parallax, EffectFade]);
window.Swiper = Swiper;

/**
 * Get files from /resources/js/public
 */
import enableAnchorTop from './public/anchor-top.js';
enableAnchorTop();
import enableNavigation from './public/navigation.js';
enableNavigation();
